import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { roadmapSteps } from '../../data/sections';
const notList = ['It’s not another lengthy theoretical textbook.', 'It’s not a complicated software platform.', 'And it’s not a replacement for your clinical judgment.'];
export function Roadmap() {
  return <section className="bg-navy px-4 py-16 text-white md:px-8 md:py-24" data-id="element-257" data-mp="2bfirublo5qq1">
      <div className="mx-auto max-w-5xl" data-id="element-258" data-mp="1xg9ctf9792nn">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[26px] font-black leading-tight sm:text-4xl" data-id="element-259" data-mp="22gxf4x2vp5x6">
          What If You Could Evaluate Movement Predictability <span className="text-gold" data-id="element-260" data-mp="1oiyz7n8wt1fk">Before</span> Approving Your Next Setup?
        </h2>

        <div className="mx-auto mt-10 max-w-2xl space-y-4" data-id="element-261" data-mp="1sj9fptubva8o">
          <div className="rounded-2xl bg-white/5 p-5 ring-1 ring-white/10" data-id="element-262" data-mp="3iungvx6izi3n">
            <p className="text-xs font-bold uppercase text-white/50" data-id="element-263" data-mp="3mws86p9i42n4">Instead of asking</p>
            <p className="mt-1 font-display text-lg font-bold text-white/60 line-through decoration-danger decoration-2" data-id="element-264" data-mp="3mufskir7u4d8">
              “Will this movement actually happen?”
            </p>
          </div>
          <div className="rounded-2xl bg-brand p-5" data-id="element-265" data-mp="8kshjwyhjpap">
            <p className="text-xs font-bold uppercase text-white/80" data-id="element-266" data-mp="8jh6rd6mhha3">You could begin asking</p>
            <p className="mt-1 font-display text-lg font-extrabold leading-snug" data-id="element-267" data-mp="3n0dy5ohaeqo">
              “What factors influence the predictability of this movement, and what should I evaluate before proceeding?”
            </p>
          </div>
        </div>

        <p className="mt-8 text-center text-[15px] text-white/75" data-id="element-268" data-mp="3lzovba2k22p6">That’s the thinking behind DENTAL PREDICTABILITY ROADMAP™.</p>

        <ul className="mx-auto mt-6 max-w-xl space-y-2" data-id="element-269" data-mp="3h0c6ijs4iljy">
          {notList.map(n => <li key={n} className="flex items-center gap-3 text-[15px] text-white/85" data-id="element-270" data-mp="118y1ihhpta9h">
              <XIcon className="h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-271" data-mp="wams27vc11rs" />
              {n}
            </li>)}
        </ul>
        <p className="mx-auto mt-5 max-w-xl text-center font-display text-lg font-extrabold leading-snug text-sky" data-id="element-272" data-mp="13crs0735bt8e">
          It’s a practical clinical reference library designed to support more structured clear aligner planning.
        </p>

        <h3 className="mt-16 text-center font-display text-2xl font-black sm:text-3xl" data-id="element-273" data-mp="1iattmbqma4n0">My 4-Step Clinical Roadmap</h3>

        <ol className="relative mx-auto mt-10 grid max-w-xl gap-6 md:max-w-none md:grid-cols-4 md:gap-5" data-id="element-274" data-mp="knleqzl4fttz">
          {roadmapSteps.map(({
          icon: Icon,
          step,
          body
        }, i) => <li key={step} className="relative flex gap-4 md:flex-col md:gap-3" data-id="element-275" data-mp="pjtry7frdcyi" data-mpi={i}>
              {i < roadmapSteps.length - 1 && <span className="absolute left-6 top-14 h-[calc(100%-32px)] w-0.5 bg-sky/30 md:left-14 md:top-6 md:h-0.5 md:w-[calc(100%-36px)]" aria-hidden="true" data-id="element-276" data-mp="zc7taz2xchk5" />}
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold text-navy" data-id="element-277" data-mp="6veyldhyxmuj">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-278" data-mp="2k4wye9d0pyl6" />
              </span>
              <div data-id="element-279" data-mp="2g3tf1cvrhkf7">
                <p className="text-xs font-bold uppercase text-sky" data-id="element-280" data-mp="2g5o3v2a5lwok">Step {i + 1}</p>
                <p className="font-display text-xl font-black uppercase" data-id="element-281" data-mp="2b4gvb106stgu">{step}</p>
                <p className="mt-1 text-[15px] leading-relaxed text-white/75" data-id="element-282" data-mp="266osvd1x1oye">{body}</p>
              </div>
            </li>)}
        </ol>

        <SectionCta label="Get Instant Access — $27" data-id="element-283" data-mp="218ndb23p87ro" />
      </div>
    </section>;
}